import React from 'react'
import { Grid as BaseGrid, styled } from '@mui/material'
import {
  Card as BaseCard,
  Table as BaseTable,
  TableRow as BaseRow,
  TableCell as BaseTableCell,
  Tooltip as BaseTooltip
} from '@chilecompra/react-kit/components'

export const Card = styled(({ children, textAlign, ...props }) => <BaseCard {...props}>{children}</BaseCard>)`
  align-items: ${props => props.alignItems};
  display: flex;
  height: ${props => props.height};
  margin: ${props => props.margin};
  width: ${props => props.width};
`

export const CardItem = styled(({ ...props }) => <div {...props} />)`
  align-items: center;
  display: flex;
  justify-content: center;
  flex-direction: ${props => props.direction || 'flex'};
  padding: ${props => props.padding};
`

export const Column = styled(({ flexBasis, flexGrow, width, ...props }) => <BaseGrid item {...props} />)`
  &.MuiGrid-root {
    flex-basis: ${props => props.flexBasis};
    flex-grow: ${props => props.flexGrow};
    margin: 0;
    width: ${props => props.width};
  }
  @media (min-width: 900px) {
    &.MuiGrid-root:first-child {
      padding-right: 30px;
    }
  }
`

export const QuestionIcon = styled('img')`
  height: 18px;
  margin: 0 0 -3px 6px;
  width: 18px;
`

export const Root = styled('div')`
  width: 100%;
`

export const Row = styled(({ ...props }) => <BaseGrid container {...props} />)``

export const Table = styled(BaseTable)(({ theme }) => ({
  '&.MuiTable-root:last-of-type': {
    padding: '0 0 15px 9px',
    width: '100%',
    [theme.breakpoints.only('xs')]: {
      padding: '0 5px 0 0',
      width: '60%'
    },
    [theme.breakpoints.only('sm')]: {
      padding: '0',
      width: '100%'
    },
    [theme.breakpoints.up('md')]: {
      width: '100%'
    }
  }
}))

export const TableRow = styled(BaseRow)`
  width: 10%;
`

export const TableCell = styled(BaseTableCell)`
  &&& {
    &.MuiTableCell-root:first-of-type,
    &.MuiTableCell-root:last-of-type {
      padding: ${props => props.padding || '15px 9px 10px 0'};
    }
  }
  max-width: 250px;
`

export const WarningImg = styled('img')`
  color: ${props => props.theme.palette.brand.black3};
  height: 48px;
  margin: ${props => props.margin};
  width: 48px;
`

export const Tooltip = styled(BaseTooltip)`
  word-break: auto-phrase;
  &.MuiTooltip-popper .MuiTooltip-tooltip {
    padding: 10px;
    ${props => props.theme.breakpoints.down('md')} {
      margin: 10px;
      max-width: 360px;
      max-height: 100%;
    }
    ${props => props.theme.breakpoints.up('md')} {
      margin: 0 10px;
      max-width: 420px;
      max-height: 100%;
    }
    & > div {
      max-height: 100%;
    }
  }
`
